import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const notifications = ['Olivia from Auckland just purchased this digital MegaPack', 'Liam from Wellington just got instant access', 'Charlotte from Christchurch just purchased The Pawfect Shot MegaPack', 'Noah from Hamilton just bought this ebook bundle', 'Amelia from Tauranga just purchased this digital guide', 'Jack from Dunedin just got access now'];
export function PurchaseNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before first popup
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    // Hide after 4 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      // Move to next notification
      setCurrentIndex(prev => (prev + 1) % notifications.length);
      // Show next after 5-6 seconds
      setTimeout(() => {
        setIsVisible(true);
      }, 5000 + Math.random() * 1000);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [isVisible]);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-177">
      <AnimatePresence data-id="element-178">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-white rounded-lg shadow-xl border border-gray-100 p-4 flex items-center gap-4 max-w-sm" data-id="element-179">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-180">
              <span className="text-green-600 text-xl" data-id="element-181">✓</span>
            </div>
            <div data-id="element-182">
              <p className="font-sans text-sm text-gray-800 font-medium leading-tight" data-id="element-183">
                {notifications[currentIndex]}
              </p>
              <p className="font-sans text-xs text-gray-400 mt-1" data-id="element-184">Just now</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}